<template>
  <main class="container mx-auto sm:px-4 pt-[3.9rem]">
    <div class="xl:flex xl:flex-wrap -mx-8">
      <CheckoutLeftPane
        :show-appointment-title="showAppointmentTitle"
        :content-column-class="contentColumnClass"
      />
      <CheckoutRightPane
        :show-desktop-doctor-card="showDesktopDoctorCard"
      />
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useCheckoutStore } from '@/stores/useCheckoutStore';

import CheckoutLeftPane from '@/views/checkout/CheckoutLeftPane.vue';
import CheckoutRightPane from '@/views/checkout/CheckoutRightPane.vue';
export default defineComponent({
  name: 'CheckoutPage',
  components: {
    CheckoutLeftPane,
    CheckoutRightPane,
  },
  setup() {
    const route = useRoute();
    const checkoutStore = useCheckoutStore();

    const currentRouteName = computed(() => (route.name ? String(route.name) : null));

    const showAppointmentTitle = computed(() => {
      const name = currentRouteName.value;
      return name !== 'BookingSuccess' && name !== 'BookingKo' && name !== 'CheckoutPrebookSuccess';
    });

    const hasCheckoutContext = computed(() => Boolean(checkoutStore.checkoutContext));

    const showSummaryPanel = computed(() => {
      const name = currentRouteName.value;
      if (!name) {
        return false;
      }
      if (name === 'BookingSuccess' || name === 'BookingKo') {
        return false;
      }
      if (name === 'CheckoutPrebookSuccess' && !hasCheckoutContext.value) {
        return false;
      }
      return true;
    });

    const showDesktopDoctorCard = computed(() => {
      return showSummaryPanel.value;
    });

    const contentColumnClass = computed(() => (showDesktopDoctorCard.value ? 'xl:w-1/2' : 'xl:w-full'));

    return {
      showAppointmentTitle,
      showDesktopDoctorCard,
      contentColumnClass,
    };
  },
});
</script>
